import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminUpdateBuyerListOwnerMutation,
  AdminUpdateBuyerListOwnerMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminUpdateBuyerListOwnerMutation = graphql(`
  mutation adminUpdateBuyerListOwner($input: AdminUpdateBuyerListOwnerInput!) {
    adminUpdateBuyerListOwner(input: $input) {
      id
      name
      ownerId
    }
  }
`);

type UpdateOwnerParams = { newOwnerGuid: string; buyerListGuid: string };

export function useAdminUpdateBuyerListOwner(
  options?: UseMutationOptions<
    AdminUpdateBuyerListOwnerMutation,
    unknown,
    AdminUpdateBuyerListOwnerMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(adminUpdateBuyerListOwnerMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["buyerList", variables.input.id]);
      options?.onSuccess?.(data, variables, context);
    },
  });
  return {
    ...rest,
    mutate: ({ buyerListGuid, newOwnerGuid }: UpdateOwnerParams) =>
      innerMutate({ input: { id: buyerListGuid, newOwnerId: newOwnerGuid } }),
  };
}
